<pmt-action-modal [title]="'assignmentSchedules.filter.title' | transloco" [onlyCancel]="false"
    [cancelButtonText]="'modal.cancelButton' | transloco" [submitButtonText]="'modal.applyButton' | transloco"
    [submitButtonIconCode]="''" (submitted)="save()" [isSaving]="isLoading" [submitButtonDisabled]="!isInitialized">

    <div class="d-flex flex-column gap-2" *ngIf="isInitialized">
        <form [formGroup]="filterForm" (ngSubmit)="save()">
            <div class="container d-flex flex-column gap-3">
                <div class="d-flex flex-column gap-3" *ngIf="facilitOptions?.length || levelOptions?.length">
                    <app-page-divider [text]="'assignmentSchedules.filter.details'| transloco"
                        [icon]="'fa-solid fa-magnifying-glass'"></app-page-divider>

                    <!-- facilities -->
                    <div *ngIf="facilitOptions?.length">
                        <label class="form-label" for="facilityIds">
                            {{'assignmentSchedules.filter.facilities' | transloco}}
                        </label>
                        <ng-select [items]="facilitOptions" bindLabel="name" bindValue="id" [multiple]="true"
                            formControlName="facilityIds" id="facilityIds">
                        </ng-select>

                    </div>

                    <!-- levels -->
                    <div *ngIf="levelOptions?.length">
                        <label class="form-label" for="levelIds">
                            {{'assignmentSchedules.filter.levels' | transloco}}
                        </label>
                        <ng-select [items]="levelOptions" bindLabel="name" bindValue="id" formControlName="levelIds"
                            [multiple]="true" id="levelIds">
                        </ng-select>
                    </div>
                </div>

                <!-- Time Period Input -->
                <app-page-divider [text]="'assignments.assignmentsFilterModal.timePeriod.title' | transloco"
                    [icon]="'fa-solid fa-clock'"></app-page-divider>
                <div class="d-flex flex-column gap-3">
                    <div class="d-flex justify-content-between">
                        <label for="show-weekdays">
                            {{"assignments.assignmentsFilterModal.filterWeekdays" | transloco}}
                        </label>
                        <div class="form-check form-switch">
                            <input id="show-weekdays" type="checkbox" class="form-check-input"
                                formControlName="isWeekdayFilterActive" />
                        </div>
                    </div>
                </div>

                <!-- Week Days Input (Bootstrap Switches) -->
                <ng-container *ngIf="filterForm.get('isWeekdayFilterActive')?.value">
                    <div>
                        <app-page-divider [text]="'shared.weekdays.title' | transloco"
                            [icon]="'fa-solid fa-calendar'"></app-page-divider>
                        <div [formGroup]="filterForm">
                            <div formGroupName="weekdays">
                                <!-- Monday -->
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <label class="me-auto" for="weekday-monday">
                                        {{"shared.weekdays.long.1" | transloco}}
                                    </label>
                                    <div class="form-check form-switch">
                                        <input id="weekday-monday" type="checkbox" class="form-check-input"
                                            formControlName="isMondayActive" />
                                    </div>
                                </div>

                                <!-- Tuesday -->
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <label class="me-auto" for="weekday-tuesday">
                                        {{"shared.weekdays.long.2" | transloco}}
                                    </label>
                                    <div class="form-check form-switch">
                                        <input id="weekday-tuesday" type="checkbox" class="form-check-input"
                                            formControlName="isTuesdayActive" />
                                    </div>
                                </div>

                                <!-- Wednesday -->
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <label class="me-auto" for="weekday-wednesday">
                                        {{"shared.weekdays.long.3" | transloco}}
                                    </label>
                                    <div class="form-check form-switch">
                                        <input id="weekday-wednesday" type="checkbox" class="form-check-input"
                                            formControlName="isWednesdayActive" />
                                    </div>
                                </div>

                                <!-- Thursday -->
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <label class="me-auto" for="weekday-thursday">
                                        {{"shared.weekdays.long.4" | transloco}}
                                    </label>
                                    <div class="form-check form-switch">
                                        <input id="weekday-thursday" type="checkbox" class="form-check-input"
                                            formControlName="isThursdayActive" />
                                    </div>
                                </div>

                                <!-- Friday -->
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <label class="me-auto" for="weekday-friday">
                                        {{"shared.weekdays.long.5" | transloco}}
                                    </label>
                                    <div class="form-check form-switch">
                                        <input id="weekday-friday" type="checkbox" class="form-check-input"
                                            formControlName="isFridayActive" />
                                    </div>
                                </div>

                                <!-- Saturday -->
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <label class="me-auto" for="weekday-saturday">
                                        {{"shared.weekdays.long.6" | transloco}}
                                    </label>
                                    <div class="form-check form-switch">
                                        <input id="weekday-saturday" type="checkbox" class="form-check-input"
                                            formControlName="isSaturdayActive" />
                                    </div>
                                </div>

                                <!-- Sunday -->
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <label class="me-auto" for="weekday-sunday">
                                        {{"shared.weekdays.long.7" | transloco}}
                                    </label>
                                    <div class="form-check form-switch">
                                        <input id="weekday-sunday" type="checkbox" class="form-check-input"
                                            formControlName="isSundayActive" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <!-- Button -->

                <div>
                    <app-page-divider [text]="'assignmentSchedules.filter.answers.title'| transloco"
                        [icon]="'fa-solid fa-list-radio'"></app-page-divider>
                    <!-- levels -->
                    <div *ngIf="mayAnswerOptions?.length">
                        <label class="form-label" for="myAnswerIds">
                            {{'assignmentSchedules.filter.myAnswer' | transloco}}
                        </label>
                        <ng-select [items]="mayAnswerOptions" bindLabel="name" bindValue="id"
                            formControlName="myAnswerIds" [multiple]="true" id="myAnswerIds">
                        </ng-select>
                    </div>
                </div>

                <div>
                    <button type="button" class="btn btn-sm btn-default w-100" (click)="clear()">
                        {{"assignmentSchedules.filter.clearButton" | transloco}}
                    </button>
                </div>
            </div>
        </form>
    </div>
    <div *ngIf="!isInitialized">
        <app-spinner></app-spinner>
    </div>
</pmt-action-modal>